import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { rangeBetween, shuffle } from '~/utils'
import { SelectionColor } from '~/bootcamp/Activities/Algebra/Components/SquareColorPicker'

import { RANGE_DATA, SIGNS, VARIABLES } from './PowerColor.constants'

export interface ClickablePartsModel {
  operator?: string
  integer: number
  variable?: string
  exponent: number
  color?: SelectionColor
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateEquationForPowerColor(
  difficultyLevel: number,
  taskHistory: string[],
): [ClickablePartsModel[], string] {
  const range = RANGE_DATA[difficultyLevel]
  const totalTerms = getRandomInt(range.minTerms, range.maxTerms)
  let equationParts: ClickablePartsModel[] = []
  const variable = VARIABLES[getRandomInt(0, VARIABLES.length - 1)]
  const exponents = [...shuffle(rangeBetween(range.minExponent, range.maxExponent + 1)).slice(0, 3), 0]
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms; i++) {
    equationParts[i] = {
      integer:
        i % 4 === 3
          ? getRandomInt(range.minInteger, range.maxInteger)
          : getRandomInt(range.minCoefficient, range.maxCoefficient),
      operator: SIGNS[getRandomInt(0, SIGNS.length - 1)],
      exponent: exponents[i % 4],
      variable,
    }
  }
  equationParts = shuffle(equationParts)
  equationParts[0].operator = undefined
  let equationString = ''
  equationParts.forEach((item) => {
    equationString += `${item.operator ? ` ${item.operator}` : ''} ${item.integer} ${item.exponent}`
  })
  if (taskHistory.includes(equationString)) return generateEquationForPowerColor(difficultyLevel, taskHistory)
  return [equationParts, equationString]
}

/**
 * check user answer
 * @param equationParts equation parts and click status
 * @returns if the answer is right or wrong
 */
export function checkAnswer(equationParts: ClickablePartsModel[]): boolean {
  const colorMap = new Map()
  const usedColors = new Map()
  // eslint-disable-next-line
  for (let i = 0; i < equationParts.length; i++) {
    const equationPart = equationParts[i]
    if (!colorMap.has(equationPart.exponent)) {
      if (usedColors.has(equationPart.color)) {
        return false
      }
      colorMap.set(equationPart.exponent, equationPart.color)
      usedColors.set(equationPart.color, 1)
    } else if (colorMap.get(equationPart.exponent) !== equationPart.color) {
      return false
    }
  }
  return true
}
